import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Input,
  Label,
  RadioButtonGroup,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';
import {
  DRAINAGE_AMOUNTS,
  DRAINAGE_TYPES,
  PRESENCE_OPTIONS,
} from '../../../constants/wounds';
import type { DrainageState } from '../assessmentFormTypes';

interface DrainageSectionProps {
  state: DrainageState;
  onChange: (update: Partial<DrainageState>) => void;
}

const DrainageSection: React.FC<DrainageSectionProps> = ({
  state,
  onChange,
}) => (
  <AccordionItem value='drainage' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Drainage
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <RadioButtonGroup
        options={PRESENCE_OPTIONS.map(o => ({
          value: o.value,
          label: o.label,
        }))}
        value={state.value}
        onValueChange={v =>
          onChange({
            value: v,
            ...(v !== 'not_assessed' && { notAssessedReason: '' }),
          })
        }
      />
      {state.value === 'not_assessed' && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {state.value === 'yes' && (
        <div className='grid grid-cols-2 gap-3'>
          <div className='space-y-1'>
            <Label className='text-xs'>Type</Label>
            <Select
              value={state.type}
              onValueChange={v =>
                onChange({ type: v, ...(v !== 'other' && { typeOther: '' }) })
              }
            >
              <SelectTrigger selectSize='sm'>
                <SelectValue placeholder='Select type...' />
              </SelectTrigger>
              <SelectContent>
                {DRAINAGE_TYPES.map(t => (
                  <SelectItem key={t.value} value={t.value}>
                    {t.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {state.type === 'other' && (
              <Input
                placeholder='Describe type...'
                value={state.typeOther}
                onChange={e => onChange({ typeOther: e.target.value })}
                inputSize='sm'
              />
            )}
          </div>
          <div className='space-y-1'>
            <Label className='text-xs'>Amount</Label>
            <Select
              value={state.amount}
              onValueChange={v => onChange({ amount: v })}
            >
              <SelectTrigger selectSize='sm'>
                <SelectValue placeholder='Select amount...' />
              </SelectTrigger>
              <SelectContent>
                {DRAINAGE_AMOUNTS.map(a => (
                  <SelectItem key={a.value} value={a.value}>
                    {a.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default DrainageSection;
